<template>
  <div>
    <Nav />
    <Banner />
    <div style="margin: auto; width: 1250px">
      <!-- 顶部主介绍卡片：参考海报感的布局 -->
      <div class="hero_card">
        <div class="hero_title_wrapper">
          <div class="hero_title_bar" />
          <div class="hero_title">玖禧猫珠宝 · 公司简介</div>
        </div>
        <div class="hero_subtitle">
          聚焦黄金、铂金、钯金、白银等贵金属的回收与综合服务，通过数字化运营为客户提供更专业、更高效、更安心的服务体验。
        </div>
        <div class="hero_badges">
          <div class="hero_badge">
            <div class="hero_badge_title">标准化流程</div>
            <div class="hero_badge_desc">检测规范 · 流程透明</div>
          </div>
          <div class="hero_badge">
            <div class="hero_badge_title">数字化系统</div>
            <div class="hero_badge_desc">行情实时 · 数据可追溯</div>
          </div>
          <div class="hero_badge">
            <div class="hero_badge_title">专业团队</div>
            <div class="hero_badge_desc">多年实战 · 服务贴心</div>
          </div>
        </div>
      </div>

      <!-- 内容分段信息 -->
      <div class="section_card">
        <div class="section_header">
          <div class="section_title_bar" />
          <div class="section_title">企业定位</div>
        </div>
        <div class="section_text">
          玖禧猫珠宝专注于黄金、铂金、钯金、白银等贵金属回收与流通服务，致力于通过标准化、数字化的运营体系，
          为个人用户与渠道客户提供公开、透明、便捷的一站式贵金属处置方案。
        </div>
      </div>

      <div class="section_card section_card_split">
        <div class="section_header">
          <div class="section_title_bar" />
          <div class="section_title">为什么选择玖禧猫</div>
        </div>
        <div class="compare_row">
          <div class="compare_block">
            <div class="compare_title">玖禧猫服务</div>
            <div class="compare_item">• 价格透明，实时行情可查询</div>
            <div class="compare_item">• 标准化检测，流程全程可追溯</div>
            <div class="compare_item">• 资金合规托管，到账更安心</div>
          </div>
          <div class="compare_vs">VS</div>
          <div class="compare_block compare_other">
            <div class="compare_title">传统渠道</div>
            <div class="compare_item">• 报价不统一，差异较大</div>
            <div class="compare_item">• 检测流程不透明</div>
            <div class="compare_item">• 资金安全缺乏保障</div>
          </div>
        </div>
      </div>

      <div class="section_card">
        <div class="section_header">
          <div class="section_title_bar" />
          <div class="section_title">业务范围</div>
        </div>
        <div class="section_text">
          服务范围覆盖：贵金属回收、仓储与托管、定制化加工、门店合作赋能、渠道回购服务等，
          为个人用户、珠宝门店、渠道商及金融机构等提供多场景、多模式的合作服务。
        </div>
      </div>

    </div>
    <div
      style="
        margin: auto;
        width: 100%;
        background-color: rgba(233, 233, 233, 0.89);
      "
    >
      <div class="jianshao" style="margin-top: 20px">
        <h2 class="one">走进玖禧猫</h2>
        <h3 class="tow">ABOUT HNEDH GROUP</h3>
        <div class="df">
          <div class="df_l">
            <img style="width: 559px;height: 313px" src="../../assets/images/company-inner.jpg" alt="" />
          </div>
          <div class="df_r">
            <div class="df_title">南京玖禧猫珠宝有限公司于2024-05创办。</div>
            <div class="di_tent">
              <div>公司位于江苏省南京市太平南路166号。</div>
              <div>
                专注贵金属综合服务，以专业、安全、透明为核心，为客户提供一站式贵金属解决方案。
                采用线上+线下实体门店双模式运营，线上便捷操作，线下备案门店安心交付，真正做到高效便捷与安全可靠兼顾。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Banner from "./components/Banner";
export default {
  name: "Home",
  components: {
    Banner, // 轮播图
  },
  props: {},
  watch: {},
  data() {
    return {
      homeTitle: "",
      homeDescription: "",
      hotlineVisible: false, // 服务支持弹窗
      certificates: [], // 存储证书数据
      qrCodeVisible: false,
      footerData: null,
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    }, 0);
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.hotline-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hotline-text {
  font-size: 18px;
  /* Increase font size */
  user-select: text;
  /* Make text selectable */
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; // Ensure the page takes at least the full height of the viewport
  padding: 20px;
  margin-top: 75px; // 添加这一行

  @media (max-width: 768px) {
    padding: 10px;
    margin-top: 60px; // 在移动设备上调整这个值
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
}

.container {
  flex: 1; // Allow the container to grow and fill available space
  margin-bottom: 100px; // Add space between container and footer
}

.introduce {
  margin: 20px 0;
  text-align: center;
}

.center {
  text-align: center;
}

.about-us {
  margin: 40px 0;
  text-align: center;

  h2 {
    font-size: 24px;
    margin-bottom: 20px;
    position: relative;
  }

  h2::after {
    content: "";
    display: block;
    width: 50px;
    height: 2px;
    background: red;
    margin: 10px auto 0;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 40px;
  }
}

.features {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  .feature {
    width: 200px;
    text-align: center;
    margin-bottom: 20px;

    .feature-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }
}

/* 新增样式 */
.info-services {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 20px 0;

  .service {
    width: 200px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.05);
    }

    .service-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }
}

.full-image {
  width: 100%;
  height: 100%;
  object-fit: cover; // 保持图片的宽高比并裁剪以填充容器
}

.scrolling-container {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  position: relative;
}

.scrolling-content {
  display: inline-block;
  animation: scroll 20s linear infinite;
  text-align: center;
  margin: 0 10px;
}

.certificate-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .scrolling-content {
    animation: scroll 10s linear infinite;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }
}
.jianshao {
  padding: 30px 0;
  margin: auto;
  width: 1250px;
  .one {
    margin-bottom: 10px;
    color: #000;
  }
  .tow {
    color: rgba(69, 74, 91, 0.2);
    margin-bottom: 10px;
  }
  .df {
    display: flex;
    .df_l {
      width: 50%;
    }
    .df_r {
      width: 50%;
      .df_title {
        font-size: 18px;
        font-weight: 700;
        color: #333;
        margin-bottom: 20px;
      }
      .di_tent {
        text-indent: 2em;
        div {
          margin-bottom: 10px;
        }
      }
    }
  }
}


.custom_nav {
  width: 100%;
  background: linear-gradient(180deg, #fffefb 0%, #fffdf8 100%);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.custom_nav_inner {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.custom_nav_back {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom_nav_title {
  font-size: 16px;
  color: rgb(159, 80, 19);
  font-weight: 600;
}

.scroll {
  height: 100%;
}

/* 顶部 Logo 区域 */
.top_logo_area {
  padding: 16px 0 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo_circle {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  background: linear-gradient(145deg, #fffdf8 0%, #ffe8c8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(224, 130, 40, 0.35);
}

.logo_tagline {
  margin-top: 10px;
  font-size: 12px;
  color: #b58a57;
}

/* 顶部主介绍卡片 */
.hero_card {
  margin: 10px 10px 0;
  padding: 16px 14px 18px;
  border-radius: 18px;
  background: linear-gradient(135deg, #fff9f1 0%, #ffe2c0 40%, #ffd1a0 100%);
  box-shadow: 0 14px 30px rgba(224, 130, 40, 0.32);
  border: 1px solid rgba(255, 213, 167, 0.8);
}

.hero_title_wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.hero_title_bar {
  width: 4px;
  height: 18px;
  border-radius: 4px;
  background: linear-gradient(180deg, #ffb55b 0%, #f88b3a 100%);
  margin-right: 8px;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(255, 181, 91, 0.4);
}

.hero_title {
  font-size: 18px;
  color: #7b3b12;
  font-weight: 600;
}

.hero_subtitle {
  margin-top: 6px;
  font-size: 13px;
  color: #7b5122;
  line-height: 1.7;
}

.hero_badges {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.hero_badge {
  flex: 1;
  padding: 8px 8px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 6px 14px rgba(224, 130, 40, 0.25);
}

.hero_badge_title {
  font-size: 13px;
  color: #7b3b12;
  font-weight: 600;
}

.hero_badge_desc {
  margin-top: 4px;
  font-size: 12px;
  color: #b58a57;
}

.section_card {
  margin: 12px 10px 0;
  padding: 14px 14px 16px;
  border-radius: 14px;
  background-color: #ffffff;
  box-shadow: 0 8px 22px rgba(224, 130, 40, 0.12);
  border: 1px solid rgba(255, 213, 167, 0.6);
}

.section_card_split {
  padding-bottom: 18px;
}

.section_header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.section_title_bar {
  width: 3px;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(180deg, #ffb55b 0%, #f88b3a 100%);
  margin-right: 6px;
  flex-shrink: 0;
}

.section_title {
  font-size: 15px;
  color: #7b3b12;
  font-weight: 600;
}

.section_text {
  margin-top: 4px;
  font-size: 13px;
  color: #946c3b;
  line-height: 1.7;
}

/* 对比布局 */
.compare_row {
  margin-top: 8px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 10px;
}

.compare_block {
  flex: 1;
  padding: 10px 10px;
  border-radius: 12px;
  background: #fff9f1;
}

.compare_other {
  background: #fdf4ec;
}

.compare_title {
  font-size: 13px;
  font-weight: 600;
  color: #7b3b12;
}

.compare_item {
  margin-top: 4px;
  font-size: 12px;
  color: #946c3b;
}

.compare_vs {
  align-self: center;
  font-size: 14px;
  font-weight: 700;
  color: #f88b3a;
}
</style>